import { useState, useEffect, useRef } from "react";

export default function SupportBubble() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const [alarms, setAlarms] = useState([]);
  const [unseen, setUnseen] = useState(0);
  const wsRef = useRef(null);
  const curRef = useRef("");
  const bodyRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
    const ws = new WebSocket(proto + "//" + window.location.host + "/ws/soporte?token=" + encodeURIComponent(token));
    wsRef.current = ws;
    ws.onmessage = (e) => {
      const m = JSON.parse(e.data);
      if (m.type === "text") {
        curRef.current += m.data;
        setMsgs(prev => {
          const copy = [...prev];
          if (copy.length && copy[copy.length - 1].role === "assistant" && copy[copy.length - 1].streaming) {
            copy[copy.length - 1] = { role: "assistant", text: curRef.current, streaming: true };
          } else {
            copy.push({ role: "assistant", text: curRef.current, streaming: true });
          }
          return copy;
        });
      } else if (m.type === "tool") {
        setMsgs(prev => [...prev, { role: "tool", text: "🔧 " + m.name }]);
      } else if (m.type === "approval") {
        setMsgs(prev => [...prev, { role: "approval", id: m.id, tool: m.tool, args: m.args, decided: false }]);
      } else if (m.type === "done") {
        setMsgs(prev => prev.map(x => x.role === "assistant" ? { ...x, streaming: false } : x));
        curRef.current = ""; setBusy(false);
      } else if (m.type === "error") {
        setMsgs(prev => [...prev, { role: "error", text: "⚠️ " + m.data }]);
        curRef.current = ""; setBusy(false);
      }
    };
    ws.onclose = () => setBusy(false);
    return () => ws.close();
  }, []);

  // Polling liviano del conteo de diagnósticos de alarma sin ver (badge).
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    let stop = false;
    const poll = async () => {
      try {
        const r = await fetch("/v1/soporte/alarm-diagnoses?unseen=1&limit=1", {
          headers: { Authorization: "Bearer " + token } });
        if (r.ok) { const d = await r.json(); if (!stop) setUnseen(d.unseen_count || 0); }
      } catch (e) { /* silencioso */ }
    };
    poll();
    const iv = setInterval(poll, 60000);
    return () => { stop = true; clearInterval(iv); };
  }, []);

  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [msgs, open]);

  const loadAlarms = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      const r = await fetch("/v1/soporte/alarm-diagnoses?limit=20", {
        headers: { Authorization: "Bearer " + token } });
      if (r.ok) { const d = await r.json(); setAlarms(d.diagnosticos || []); }
      await fetch("/v1/soporte/alarm-diagnoses/seen", {
        method: "POST",
        headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
        body: JSON.stringify({}) });
      setUnseen(0);
    } catch (e) { /* silencioso */ }
  };

  const toggle = () => {
    setOpen(o => {
      const nx = !o;
      if (nx) loadAlarms();
      return nx;
    });
  };

  const send = () => {
    if (!input.trim() || busy || !wsRef.current || wsRef.current.readyState !== 1) return;
    const next = [...msgs, { role: "user", text: input.trim() }];
    setMsgs(next); setBusy(true); curRef.current = "";
    const history = next.filter(m => m.role === "user" || m.role === "assistant")
                        .map(m => ({ role: m.role, content: m.text }));
    wsRef.current.send(JSON.stringify({ messages: history }));
    setInput("");
  };

  const decide = (id, ok) => {
    if (!wsRef.current || wsRef.current.readyState !== 1) return;
    wsRef.current.send(JSON.stringify(ok ? { approve: id } : { reject: id }));
    setBusy(true);
    setMsgs(prev => prev.map(x => (x.role === "approval" && x.id === id) ? { ...x, decided: true, ok } : x));
  };

  if (!localStorage.getItem("token")) return null;

  return (
    <>
      {open && (
        <div style={{ position: "fixed", bottom: 88, right: 22, width: 380, height: 520, zIndex: 9999,
          background: "#0e1626", border: "1px solid rgba(255,255,255,0.10)", borderRadius: 14,
          boxShadow: "0 12px 40px rgba(0,0,0,0.5)", display: "flex", flexDirection: "column", overflow: "hidden" }}>
          <div style={{ padding: "10px 14px", background: "#162035", borderBottom: "1px solid rgba(255,255,255,0.07)",
            display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <strong style={{ fontSize: 14, color: "#e8edf5" }}>🤖 Soporte (Claude)</strong>
            <button onClick={() => setOpen(false)} style={{ background: "none", border: "none", color: "#9fb0c8", cursor: "pointer", fontSize: 16 }}>✕</button>
          </div>
          <div ref={bodyRef} style={{ flex: 1, overflowY: "auto", padding: 12, display: "flex", flexDirection: "column", gap: 8 }}>
            {alarms.length > 0 && (
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <div style={{ color: "#ff8a93", fontSize: 11, fontWeight: 700, letterSpacing: 0.3 }}>🚨 DIAGNÓSTICOS POR ALARMA</div>
                {alarms.map(a => (
                  <div key={a.id} style={{ background: "#2a1414", border: "1px solid #ff475744",
                    borderRadius: 10, padding: "8px 11px", fontSize: 12, color: "#e8edf5" }}>
                    <div style={{ fontWeight: 600, color: "#ff8a93" }}>{a.alert_key} · {a.severity}</div>
                    <div style={{ color: "#9fb0c8", margin: "2px 0 5px" }}>{a.summary}</div>
                    <div style={{ whiteSpace: "pre-wrap" }}>{a.diagnostico}</div>
                    <div style={{ color: "#5f6f88", fontSize: 10.5, marginTop: 4 }}>{a.ts}</div>
                  </div>
                ))}
                <div style={{ borderBottom: "1px solid rgba(255,255,255,0.07)", margin: "2px 0" }} />
              </div>
            )}
            {msgs.length === 0 && alarms.length === 0 && <p style={{ color: "#6c7a93", fontSize: 12.5 }}>
              Diagnóstico de la infra (solo lectura). Ej: <em>"¿por qué no registra el cliente 59343901991?"</em></p>}
            {msgs.map((m, i) => (
              m.role === "approval" ? (
                <div key={i} style={{ alignSelf: "flex-start", background: "#2a1f0e",
                  border: "1px solid #f5a62355", borderRadius: 10, padding: "9px 11px", maxWidth: "92%", fontSize: 12.5, color: "#e8edf5" }}>
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>⚠️ Aprobación requerida</div>
                  <div style={{ fontFamily: "var(--font-mono)", fontSize: 11.5, color: "#f5d9a3" }}>
                    {m.tool}({JSON.stringify(m.args)})
                  </div>
                  {!m.decided ? (
                    <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                      <button onClick={() => decide(m.id, true)} style={{ background: "#00c98d", border: "none", borderRadius: 7, color: "#06121f", fontWeight: 600, padding: "5px 12px", cursor: "pointer", fontSize: 12 }}>Aprobar</button>
                      <button onClick={() => decide(m.id, false)} style={{ background: "#ff4757", border: "none", borderRadius: 7, color: "#fff", padding: "5px 12px", cursor: "pointer", fontSize: 12 }}>Rechazar</button>
                    </div>
                  ) : (
                    <div style={{ marginTop: 6, color: m.ok ? "#00c98d" : "#ff6b78" }}>{m.ok ? "✅ Aprobada" : "❌ Rechazada"}</div>
                  )}
                </div>
              ) : (
                <div key={i} style={{ alignSelf: m.role === "user" ? "flex-end" : "flex-start",
                  background: m.role === "user" ? "#1a8cff22" : m.role === "error" ? "#ff475722" : "#162035",
                  border: "1px solid rgba(255,255,255,0.06)", borderRadius: 10, padding: "7px 11px",
                  maxWidth: "88%", fontSize: 12.5, color: "#e8edf5", whiteSpace: "pre-wrap" }}>
                  {m.text}
                </div>
              )
            ))}
          </div>
          <div style={{ display: "flex", gap: 6, padding: 10, borderTop: "1px solid rgba(255,255,255,0.07)" }}>
            <input value={input} onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === "Enter" && send()} placeholder="Escribí tu consulta…"
              disabled={busy} style={{ flex: 1, background: "#0a121f", border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: 8, padding: "7px 10px", color: "#e8edf5", fontSize: 12.5 }} />
            <button onClick={send} disabled={busy} style={{ background: "#1a8cff", border: "none", borderRadius: 8,
              color: "#fff", padding: "0 14px", cursor: busy ? "default" : "pointer", fontSize: 13 }}>
              {busy ? "…" : "➤"}
            </button>
          </div>
        </div>
      )}
      <button onClick={toggle} title="Soporte Claude"
        style={{ position: "fixed", bottom: 22, right: 22, width: 56, height: 56, zIndex: 9999, borderRadius: "50%",
          background: "#1a8cff", border: "none", color: "#fff", fontSize: 24, cursor: "pointer",
          boxShadow: "0 6px 20px rgba(26,140,255,0.45)" }}>
        {open ? "✕" : "🤖"}
        {!open && unseen > 0 && (
          <span style={{ position: "absolute", top: -2, right: -2, background: "#ff4757", color: "#fff",
            borderRadius: "50%", minWidth: 20, height: 20, fontSize: 11, fontWeight: 700, padding: "0 5px",
            display: "flex", alignItems: "center", justifyContent: "center", border: "2px solid #0e1626" }}>
            {unseen}
          </span>
        )}
      </button>
    </>
  );
}
